"use client";

import { useTranslations } from "i18n";
import type { PricesPageProps } from "types/prices";

import TokenCardSlider from "../TokenCardSlider";
import ReferralCard from "../ReferralCard";
import DetailsCard from "../DetailsCard";
import StoreCard from "../StoreCard";
import TradeForm from "../TradeForm/TradeForm";
import { handlePricePageData } from "utils/coinPrices";
import get from "lodash/get";
import { FILES } from "i18n/constants";
import DownloadGeminiMobileApp from "./DownloadGeminiMobileApp";

export const PricePageSidePanel = (props: PricesPageProps) => {
  const {
    currentCoinDetail,
    initialOverview,
    referralCardEntry,
    trendingCoins,
    recentlyLaunchedCoins,
    topMoverCoins
  } = props;
  const coinSymbolName = get(currentCoinDetail, "coin");
  const isTrading = get(currentCoinDetail, "isTrading");
  const isCustody = get(currentCoinDetail, "isCustody");
  const { tradeForm } = handlePricePageData(props);
  const t = useTranslations(FILES.PRICES);

  return (
    <div className="hidden sm:block">
      {isTrading && initialOverview?.priceOverview?.ask && (
        <div className="hidden [@media(min-width:904px)]:flex">
          <TradeForm tradeForm={tradeForm} {...props} />
        </div>
      )}
      <div className="mb-[48px] hidden [@media(min-width:904px)]:flex">
        <DownloadGeminiMobileApp />
      </div>
      {!isTrading && isCustody && (
        <StoreCard
          coinName={currentCoinDetail.name}
          coinSymbol={coinSymbolName}
        />
      )}
      {!isTrading && !isCustody && (
        <DetailsCard coinName={currentCoinDetail.name} />
      )}
      <div className="hidden [@media(min-width:905px)]:flex">
        <ReferralCard referralCardEntry={referralCardEntry} />
      </div>
      <div className="hidden [@media(min-width:905px)]:block">
        <TokenCardSlider
          title={t("trendingTitle")}
          coinsArray={trendingCoins}
        />
        <TokenCardSlider
          title={t("topMoversTitle")}
          coinsArray={topMoverCoins}
        />
        <TokenCardSlider
          title={t("recentTokensTitle")}
          coinsArray={recentlyLaunchedCoins}
        />
      </div>
    </div>
  );
};
